import HttpClient from '../utils/http-client';
import { firstValueFrom } from 'rxjs';
import { AIChatPayload, AIChatResponse } from '../types/aiChat';

const getHttpClient = () => {
    const uid = localStorage.getItem('user_uid') || '';
    const cid = localStorage.getItem('cid');
    return new HttpClient(uid, cid);
};

export const aiChatService = {
    sendMessage: async (payload: AIChatPayload): Promise<AIChatResponse> => {
        const http = getHttpClient();
        return firstValueFrom(http.post<AIChatResponse>('/ai/chat', payload));
    }
};
